import { getApiV1AuthUserinfoOptions } from "Infrastructure/Api/generated/@tanstack/react-query.gen";
import { ApplicationErrorPage } from "Infrastructure/Pages/ApplicationErrorPage";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { useQuery } from "@tanstack/react-query";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate, Outlet, useLocation } from "react-router";

export const UnauthenticatedRoute = () => {
	const { data, isLoading, error } = useQuery(getApiV1AuthUserinfoOptions());
	const location = useLocation();

	if (isLoading) return <div />;

	// Broker auth always runs to completion — even if the browser still holds
	// a stale JWT, the incoming broker token must be allowed to overwrite the
	// current identity (different tenant / user).
	const isBrokerAuthRoute = location.pathname === AppRouting.BrokerAuth.path();

	// Require both: cached data AND no error. After sign-out the cache may
	// briefly hold stale `data` alongside a 401 `error` — redirecting on
	// `data` alone causes a redirect ping-pong with AuthenticatedRoute.
	if (data && !error && !isBrokerAuthRoute) {
		return <Navigate to={AppRouting.Dashboard.path()} replace />;
	}

	return (
		<ErrorBoundary FallbackComponent={ApplicationErrorPage}>
			<Outlet />
		</ErrorBoundary>
	);
};
